export const LOGIN_NAV = [
  {
    "title": "Masuk/Daftar",
    "link": "#",
    "iconName": "login",
    "target": "_blank",
    "position": "left",
    "type": "prevent",
    "rel": "login"
  }
];
